import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import areaStatementCreateActions from "../actions";
import ICustomer from "models/ICustomer";
import IUser from "models/IUser";
import BackgroundBlock from "../../deliveryNotes/partials/BackgroundBlock";
import Input from "components/Input";
import CNBDatePicker from "components/CNBDatePicker";
import Checkbox from "components/Checkbox";
import Button from "components/Button";
import Select from "components/Select";
import _ from "lodash";
import { URLS } from "constants/urlConstants";
import { History } from "history";
import Swal from "helpers/swal";

interface IProps {
  currentCustomer: ICustomer;
  createLelie: (object: any) => void;
  userName: string;
  user: IUser;
  userLanguage: string;
  statementLine: any;
  history: History;
  intl: any;
}

interface IState {
  [key: string]: any;
  error: any;
  isFormValid: boolean;
  touched: any;
  formError?: any[];

  Id: string;
  noStatementLine: boolean;
  leverbaar: {
    leverbaar_1: Array<{
      area: string;
      harvestYear: string;
      RR: string;
      description: string;
      x_cord: string;
      y_cord: string;
    }>;
    leverbaar_2e: Array<{
      area: string;
      harvestYear: string;
      RR: string;
      description: string;
      x_cord: string;
      y_cord: string;
    }>;
    leverbaar_1e: Array<{
      area: string;
      harvestYear: string;
      RR: string;
      description: string;
      x_cord: string;
      y_cord: string;
    }>;
  };
  schub: {
    schub_1: Array<{
      area: string;
      harvestYear: string;
      RR: string;
      description: string;
      x_cord: string;
      y_cord: string;
    }>;
    schub_2e: Array<{
      area: string;
      harvestYear: string;
      RR: string;
      description: string;
      x_cord: string;
      y_cord: string;
    }>;
    schub_1e: Array<{
      area: string;
      harvestYear: string;
      RR: string;
      description: string;
      x_cord: string;
      y_cord: string;
    }>;
  };
  plantTissue: Array<{
    weefselkweek: {
      wArea: string;
      wHarvestYear: string;
      wGreenHouse: string;
      wRR: string;
      wX_cord: string;
      wY_cord: string;
    };
    laboratorium: {
      lArea: string;
      lHarvestYear: string;
      lGreenHouse: string;
      lRR: string;
      lX_cord: string;
      lY_cord: string;
    };
  }>;

  areaalAvailable: boolean;

  plantingMaterial: Array<{
    buyerCompanyName: string;
    address: string;
    residence: string;
    numberOfPortions: string;
    quantity: string;
    orderNumber: string;
    IVB: string | null;
  }>;

  licensor: Partial<ICustomer>;
  licensee: Partial<ICustomer>;
}

class AreaStatementLelie extends React.Component<IProps, IState> {
  private baseState: any;

  constructor(props) {
    super(props);

    const { statementLine } = this.props;
    this.state = {
      Id: statementLine?.Id,
      isFormValid: false,
      error: {
        plantingMaterials: [
          {
            buyerCompanyName: null,
            address: null,
            residence: null,
            numberOfPortions: null,
            quantity: null,
            orderNumber: null,
            IVB: { error: "Required", touched: false },
          },
        ],
      },
      touched: {},
      itemId: statementLine?.LicenceContractLine?.Item?.Number,
      date: new Date(),
      cultivar: statementLine
        ? statementLine?.LicenceContractLine?.LicenceContract?.Cultivar
        : "",
      harvestYear: statementLine
        ? statementLine?.AreaStatement?.HarvestYear
        : null,

      noStatementLine: false,
      leverbaar: {
        leverbaar_1: [
          {
            area: "Leverbaar 1 jarig",
            harvestYear: statementLine
              ? statementLine?.AreaStatement?.HarvestYear
              : null,
            RR: "",
            description: "",
            x_cord: "",
            y_cord: "",
          },
        ],
        leverbaar_1e: [
          {
            area: "Leverbaar 1e jaars",
            harvestYear: statementLine
              ? statementLine?.AreaStatement?.HarvestYear + 1
              : null,
            RR: "",
            description: "",
            x_cord: "",
            y_cord: "",
          },
        ],
        leverbaar_2e: [
          {
            area: "Leverbaar 2e jaars",
            harvestYear: statementLine
              ? statementLine?.AreaStatement?.HarvestYear
              : null,
            RR: "",
            description: "",
            x_cord: "",
            y_cord: "",
          },
        ],
      },
      schub: {
        schub_1: [
          {
            area: "Schub 1 jarig",
            harvestYear: statementLine
              ? statementLine?.AreaStatement?.HarvestYear
              : null,
            RR: "",
            description: "",
            x_cord: "",
            y_cord: "",
          },
        ],
        schub_1e: [
          {
            area: "Schub 1e jaars",
            harvestYear: statementLine
              ? statementLine?.AreaStatement?.HarvestYear + 1
              : null,
            RR: "",
            description: "",
            x_cord: "",
            y_cord: "",
          },
        ],
        schub_2e: [
          {
            area: "Schub 2e jaars",
            harvestYear: statementLine
              ? statementLine?.AreaStatement?.HarvestYear
              : null,
            RR: "",
            description: "",
            x_cord: "",
            y_cord: "",
          },
        ],
      },

      plantTissue: [
        {
          weefselkweek: {
            wArea: "Weefselkweek",
            wHarvestYear: statementLine
              ? statementLine?.AreaStatement?.HarvestYear
              : null,
            wRR: "",
            wGreenHouse: "",
            wX_cord: "",
            wY_cord: "",
          },
          laboratorium: {
            lArea: "Laboratorium",
            lHarvestYear: statementLine
              ? statementLine?.AreaStatement?.HarvestYear
              : null,
            lRR: "",
            lGreenHouse: "",
            lX_cord: "",
            lY_cord: "",
          },
        },
      ],

      areaalAvailable: false,
      plantingMaterial: [
        {
          buyerCompanyName: "",
          address: "",
          residence: "",
          numberOfPortions: "",
          quantity: "",
          orderNumber: "",
          IVB: "",
        },
      ],
      licensor: statementLine?.LicenceContractLine?.LicenceContract?.Licensor,
      licensee: statementLine?.LicenceContractLine?.LicenceContract?.Licensee,
    };

    this.baseState = this.state;
  }

  public componentDidMount() {
    const { statementLine, history } = this.props;
    if (_.isEmpty(statementLine) || !statementLine) {
      history.push(URLS.AREA_STATEMENT_CREATE_URL);
      return;
    }
  }

  public componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ) {
    if (
      prevState.areaalAvailable !== this.state.areaalAvailable ||
      prevState.noStatementLine !== this.state.noStatementLine
    ) {
      // this.validateLines();
    }
    if (
      prevState.leverbaar !== this.state.leverbaar ||
      prevState.schub !== this.state.schub ||
      prevState.plantingMaterial !== this.state.plantingMaterial
    ) {
      // this.validateLines();
    }
  }

  private handleFieldChange(name, value) {
    this.setState({ [name]: value });
  }

  private handleAreaalChange(name, value) {
    if (name === "notAreaalAvailable") {
      this.setState({ areaalAvailable: false });
    } else {
      this.setState({ areaalAvailable: true });
    }
  }
  private formatSchubTarget = (target) => {
    let schubTarget = "";
    switch (target) {
      case "schub_1":
        schubTarget = "Schub 1 jarig";
        break;
      case "schub_1e":
        schubTarget = "Schub 1e jaars";
        break;
      case "schub_2e":
        schubTarget = "Schub 2e jaars";
        break;
    }
    return schubTarget;
  };
  private handleAddSchub = (e, target) => {
    e.preventDefault();
    const schubTarget = this.formatSchubTarget(target);
    const { statementLine } = this.props;
    const emptyState = {
      area: schubTarget,
      harvestYear:
        target === "schub_1e"
          ? statementLine?.AreaStatement?.HarvestYear + 1
          : statementLine?.AreaStatement?.HarvestYear,
      RR: "",
      description: "",
      x_cord: "",
      y_cord: "",
    };
    this.setState({
      schub: {
        ...this.state.schub,
        [target]: this.state.schub[target].concat([emptyState]),
      },
    });
  };

  private handleAddLeverBaar = (e, target) => {
    e.preventDefault();
    const { statementLine } = this.props;
    const emptyState = {
      area:
        target === "leverbaar_1e"
          ? "Leverbaar 1e jaars"
          : target === "leverbaar_1"
          ? "Leverbaar 1 jarig"
          : "Leverbaar 2e jaars",
      harvestYear:
        target === "leverbaar_1e"
          ? statementLine?.AreaStatement?.HarvestYear + 1
          : statementLine?.AreaStatement?.HarvestYear,
      RR: "",
      description: "",
      x_cord: "",
      y_cord: "",
    };
    this.setState({
      leverbaar: {
        ...this.state.leverbaar,
        [target]: this.state.leverbaar[target].concat([emptyState]),
      },
    });
  };

  private handleAddPlantTissue = (e) => {
    e.preventDefault();
    const { statementLine } = this.props;
    const emptyState = {
      weefselkweek: {
        wArea: "Weefselkweek",
        wHarvestYear: statementLine?.AreaStatement?.HarvestYear,
        wRR: "",
        wGreenHouse: "",
        wX_cord: "",
        wY_cord: "",
      },
      laboratorium: {
        lArea: "Laboratorium",
        lHarvestYear: statementLine?.AreaStatement?.HarvestYear,
        lRR: "",
        lGreenHouse: "",
        lX_cord: "",
        lY_cord: "",
      },
    };
    this.setState({
      plantTissue: this.state.plantTissue.concat([emptyState]),
    });
  };

  private onLeverBaarChange = (e: any, index: number, target: string) => {
    const { leverbaar } = this.state;
    const updatedValues = this.state.leverbaar[target].map(
      (transaction, i: number) =>
        index === i
          ? Object.assign(transaction, { [e.target.name]: e.target.value })
          : transaction
    );
    this.setState((prevState) => ({
      ...prevState,
      [leverbaar[target]]: updatedValues,
    }));
    // this.validateLines();
  };

  private onSchubChange = (e: any, index: number, target: string) => {
    const { schub } = this.state;
    const updatedValues = this.state.schub[target].map(
      (transaction, i: number) =>
        index === i
          ? Object.assign(transaction, { [e.target.name]: e.target.value })
          : transaction
    );
    this.setState((prevState) => ({
      ...prevState,
      [schub[target]]: updatedValues,
    }));
    // this.validateLines();
  };

  private handleAddPlantingMaterial = (e) => {
    e.preventDefault();
    const emptyState = {
      buyerCompanyName: "",
      address: "",
      residence: "",
      numberOfPortions: "",
      quantity: "",
      orderNumber: "",
      IVB: "",
    };

    this.setState({
      plantingMaterial: this.state.plantingMaterial.concat([emptyState]),
    });
  };

  private onPlantingMaterialChange = (e: any, index: number) => {
    const updatedValues = this.state.plantingMaterial.map(
      (transaction, i: number) =>
        index === i
          ? Object.assign(transaction, { [e.target.name]: e.target.value })
          : transaction
    );
    this.setState({ ...this.state, plantingMaterial: [...updatedValues] });
    // this.validateLines();
  };

  private onPlantTissueChange = (e: any, index: number, target: string) => {
    const updatedValues = this.state.plantTissue.map((transaction, i: number) =>
      index === i
        ? Object.assign(transaction[target], {
            [e.target.name]: e.target.value,
          })
        : transaction
    );
    this.setState({ ...this.state.plantTissue, target: [...updatedValues] });
    // this.validateLines();
  };

  private onPlantingMaterialIVBChange = (e: any, index: number) => {
    const updatedValues = this.state.plantingMaterial.map(
      (transaction, i: number) =>
        index === i ? Object.assign(transaction, { IVB: e.value }) : transaction
    );
    this.setState({ ...this.state, plantingMaterial: [...updatedValues] });
    // this.validateLines();
  };

  private handleDeleteRow = (e: Event, index: number, object, key) => {
    e.preventDefault();
    const updatedList = [...this.state[object][key]];
    updatedList.splice(index, 1);
    this.setState({
      [object]: { ...this.state[object], [key]: updatedList },
    });
  };

  private handleDeleteTissue = (e: Event, index: number) => {
    e.preventDefault();
    const updatedList = [...this.state.plantTissue];
    updatedList.splice(index, 1);
    this.setState({ plantTissue: updatedList });
    // this.validateLines();
  };

  private handleDeletePlantingRow = (e: Event, index: number) => {
    e.preventDefault();
    const updatedList = [...this.state.plantingMaterial];
    updatedList.splice(index, 1);
    this.setState({
      plantingMaterial: updatedList,
    });
  };

  private handleSubmitForm = (e): void => {
    e.preventDefault();
    const { createLelie } = this.props;
    createLelie(this.state);
  };

  private handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      return false;
    }
  };

  private validateLines(): boolean {
    let isLineFilled = false;
    const {
      leverbaar,
      schub,
      plantTissue,
      plantingMaterial,
      areaalAvailable,
      noStatementLine,
    } = this.state;
    if (noStatementLine && !areaalAvailable) {
      this.setState({ isFormValid: true });
      return true;
    }

    if (!noStatementLine) {
      const generatedArray = { leverbaar, schub };
      for (const item in generatedArray) {
        if (generatedArray.hasOwnProperty(item)) {
          for (const topLevelKey in generatedArray[item]) {
            if (generatedArray[item].hasOwnProperty(topLevelKey)) {
              for (
                let index = 0;
                index < generatedArray[item][topLevelKey].length;
                index++
              ) {
                const filteredLines = _.flow([
                  Object.entries,
                  (arr) =>
                    arr.filter(
                      ([key, value]) => key !== "area" && key !== "harvestYear"
                    ),
                  Object.fromEntries,
                ])(generatedArray[item][topLevelKey][index]);
                isLineFilled = Object.values(filteredLines).every(
                  (value) => value !== null && value !== ""
                );
                if (isLineFilled) {
                  this.setState({ isFormValid: true });
                  return true;
                } else {
                  this.setState({ isFormValid: false });
                }
              }
            }
          }
        }
      }
      for (let index = 0; index < plantTissue.length; index++) {
        for (const key in plantTissue[index]) {
          if (plantTissue[index].hasOwnProperty(key)) {
            if (!isLineFilled) {
              isLineFilled = Object.values(plantTissue[index][key]).every(
                (value) => value !== null && value !== ""
              );
            }
            if (isLineFilled) {
              this.setState({ isFormValid: true });
              return true;
            } else {
              this.setState({ isFormValid: false });
            }
          }
        }
      }
    }

    if (areaalAvailable && plantingMaterial.length > 0) {
      for (let index = 0; index < plantingMaterial.length; index++) {
        isLineFilled = Object.values(plantingMaterial[index]).every(
          (value) => value !== null && value !== ""
        );
        if (isLineFilled) {
          this.setState({ isFormValid: true });
        } else {
          this.setState({ isFormValid: false });
          break;
        }
      }
    }
    if ((areaalAvailable && !isLineFilled) || plantingMaterial.length < 1) {
      this.setState({ isFormValid: false });
      return false;
    }

    return isLineFilled;
  }

  private isFormInvalidOnSubmit(): boolean {
    const {
      intl: { formatMessage },
    } = this.props;
    let isPartiallyFilled;
    const { leverbaar, schub, plantTissue, noStatementLine } = this.state;
    if (!noStatementLine) {
      const generatedArray = { leverbaar, schub };
      for (const item in generatedArray) {
        if (generatedArray.hasOwnProperty(item)) {
          for (const topLevelKey in generatedArray[item]) {
            if (generatedArray[item].hasOwnProperty(topLevelKey)) {
              for (
                let index = 0;
                index < generatedArray[item][topLevelKey].length;
                index++
              ) {
                // check if key is not area or harvestYear
                const filteredLines = _.flow([
                  Object.entries,
                  (arr) =>
                    arr.filter(
                      ([key, value]) => key !== "area" && key !== "harvestYear"
                    ),
                  Object.fromEntries,
                ])(generatedArray[item][topLevelKey][index]);
                isPartiallyFilled =
                  isEmpty(Object.values(filteredLines)) &&
                  hasValue(Object.values(filteredLines));
                // if (isPartiallyFilled) {
                //   Swal.alert("warning", `${topLevelKey}${formatMessage({ id: "NOT_COMPLETELY_FILLED" })}`);
                //   return true;
                // }
              }
            }
          }
        }
      }
    }

    for (let index = 0; index < plantTissue.length; index++) {
      for (const key in plantTissue[index]) {
        if (plantTissue[index].hasOwnProperty(key)) {
          const filteredLines = _.flow([
            Object.entries,
            (arr) =>
              arr.filter(
                ([key, value]) =>
                  key !== "wArea" &&
                  key !== "wHarvestYear" &&
                  key !== "lArea" &&
                  key !== "lHarvestYear"
              ),
            Object.fromEntries,
          ])(plantTissue[index][key]);
          isPartiallyFilled =
            isEmpty(Object.values(filteredLines)) &&
            hasValue(Object.values(filteredLines));
          // if (isPartiallyFilled) {
          //   Swal.alert(
          //     "warning",
          //     `${key}
          //       ${formatMessage({ id: "NOT_COMPLETELY_FILLED" })}`
          //   );
          //   return true;
          // }
        }
      }
    }

    function isEmpty(array) {
      return array.some((value) => value === "");
    }

    function hasValue(array) {
      return array.some((value) => !!value);
    }

    return isPartiallyFilled;
  }

  public render() {
    const {
      date,
      isFormValid,
      cultivar,
      harvestYear,
      noStatementLine,
      areaalAvailable,
      leverbaar,
      schub,
      plantTissue,
      plantingMaterial,
    } = this.state;
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div>
        <FormattedMessage id="AREA_STATEMENT_MAKE" tagName="h1" />
        <form id="new-cultivation-advice" onKeyDown={this.handleKeyDown}>
          <BackgroundBlock className="advice-form" key={1}>
            <Input
              name="harvestYear"
              label="HARVEST_YEAR"
              placeholder="HARVEST_YEAR"
              value={harvestYear}
              onChange={(e) =>
                this.handleFieldChange("harvestYear", e.target.value)
              }
              required
              disabled
            />
            <Input
              name="cultivar"
              label="CULTIVAR"
              placeholder="CULTIVAR"
              value={cultivar}
              onChange={(e) =>
                this.handleFieldChange("cultivar", e.target.value)
              }
              required
              disabled
            />
            <div className="datum">
              <FormattedMessage id="DATE" tagName="label" />
              <CNBDatePicker
                name="date"
                startDate={new Date()}
                onChange={(value) => this.handleFieldChange("date", value)}
              />
            </div>
            <div className="checkbox-row">
              <Checkbox
                checked={noStatementLine}
                onChange={(value) =>
                  this.handleFieldChange("noStatementLine", value)
                }
                borderColor="#CDD2D6"
                labelText={"AREA_STATEMENT_AVAILABLE"}
              />
            </div>
          </BackgroundBlock>
          {!noStatementLine && (
            <BackgroundBlock className="advice-form" key={2}>
              <div className="leverBaarTable mt-30 pb-20 border-bottom">
                <table className="leverBaarTable">
                  <thead>
                    <tr>
                      <th className="capitalizeText">
                        <FormattedMessage id="SURFACE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="HARVEST_YEAR" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="RR" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="CULTIVATION_LOCATIONS" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="X_COORDINATE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="Y_COORDINATE" />
                      </th>
                      <th className="capitalizeText"> &nbsp; </th>
                    </tr>
                  </thead>
                  <tbody>
                    {leverbaar.leverbaar_1.map((leverbaar1, index) => (
                      <tr key={`leverbaar1` + index}>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={leverbaar1.area || ""}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={leverbaar1.harvestYear || ""}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1")
                            }
                            name="RR"
                            placeholder="RR"
                            className="half-width-50 "
                            value={leverbaar1.RR}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1")
                            }
                            name="description"
                            placeholder="CULTIVATION_LOCATIONS"
                            className="half-width-50"
                            value={leverbaar1.description}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1")
                            }
                            name="x_cord"
                            placeholder="X_COORDINATE"
                            className="half-width-50 "
                            value={leverbaar1.x_cord}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1")
                            }
                            name="y_cord"
                            placeholder="Y_COORDINATE"
                            className="half-width-50 "
                            value={leverbaar1.y_cord}
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeleteRow(
                                e,
                                index,
                                "leverbaar",
                                "leverbaar_1"
                              )
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td className="addRow">
                        <Button
                          onClick={(e) =>
                            this.handleAddLeverBaar(e, "leverbaar_1")
                          }
                          kind="primary"
                          type="button"
                          className="p-10"
                        >
                          PLUS_SIGN
                        </Button>
                      </td>
                    </tr>

                    {leverbaar.leverbaar_2e.map((leverbaar2e, index) => (
                      <tr key={`leverbaar2e` + index}>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar2e")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={leverbaar2e.area || ""}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_2e")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={leverbaar2e.harvestYear || ""}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_2e")
                            }
                            name="RR"
                            placeholder="RR"
                            className="half-width-50 "
                            value={leverbaar2e.RR}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_2e")
                            }
                            name="description"
                            placeholder="CULTIVATION_LOCATIONS"
                            className="half-width-50"
                            value={leverbaar2e.description}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_2e")
                            }
                            name="x_cord"
                            placeholder="X_COORDINATE"
                            className="half-width-50 "
                            value={leverbaar2e.x_cord}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_2e")
                            }
                            name="y_cord"
                            placeholder="Y_COORDINATE"
                            className="half-width-50 "
                            value={leverbaar2e.y_cord}
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeleteRow(
                                e,
                                index,
                                "leverbaar",
                                "leverbaar_2e"
                              )
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td className="addRow">
                        <Button
                          onClick={(e) =>
                            this.handleAddLeverBaar(e, "leverbaar_2e")
                          }
                          kind="primary"
                          type="button"
                          className="p-10"
                        >
                          PLUS_SIGN
                        </Button>
                      </td>
                    </tr>

                    {leverbaar.leverbaar_1e.map((leverbaar1e, index) => (
                      <tr key={"leverbaar1e" + index}>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1e")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={leverbaar1e.area || ""}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1e")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={leverbaar1e.harvestYear || ""}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1e")
                            }
                            name="RR"
                            placeholder="RR"
                            className="half-width-50 "
                            value={leverbaar1e.RR}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1e")
                            }
                            name="description"
                            placeholder="CULTIVATION_LOCATIONS"
                            className="half-width-50"
                            value={leverbaar1e.description}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1e")
                            }
                            name="x_cord"
                            placeholder="X_COORDINATE"
                            className="half-width-50 "
                            value={leverbaar1e.x_cord}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onLeverBaarChange(e, index, "leverbaar_1e")
                            }
                            name="y_cord"
                            placeholder="Y_COORDINATE"
                            className="half-width-50 "
                            value={leverbaar1e.y_cord}
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeleteRow(
                                e,
                                index,
                                "leverbaar",
                                "leverbaar_1e"
                              )
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td className="addRow">
                        <Button
                          onClick={(e) =>
                            this.handleAddLeverBaar(e, "leverbaar_1e")
                          }
                          kind="primary"
                          type="button"
                          className="p-10"
                        >
                          PLUS_SIGN
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </BackgroundBlock>
          )}
          {!noStatementLine && (
            <BackgroundBlock className="advice-form" key={3}>
              <div className="leverBaarTable mt-30 pb-20 border-bottom">
                <table className="leverBaarTable">
                  <thead>
                    <tr>
                      <th className="capitalizeText">
                        <FormattedMessage id="SURFACE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="HARVEST_YEAR" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="RR" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="CULTIVATION_LOCATIONS" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="X_COORDINATE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="Y_COORDINATE" />
                      </th>
                      <th className="capitalizeText"> &nbsp; </th>
                    </tr>
                  </thead>
                  <tbody>
                    {schub.schub_1.map((schub1, index) => (
                      <tr key={"schub1" + index}>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={schub1.area}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={schub1.harvestYear || ""}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1")
                            }
                            name="RR"
                            placeholder="RR"
                            className="half-width-50 "
                            value={schub1.RR}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1")
                            }
                            name="description"
                            placeholder="CULTIVATION_LOCATIONS"
                            className="half-width-50"
                            value={schub1.description}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1")
                            }
                            name="x_cord"
                            placeholder="X_COORDINATE"
                            className="half-width-50 "
                            value={schub1.x_cord}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1")
                            }
                            name="y_cord"
                            placeholder="Y_COORDINATE"
                            className="half-width-50 "
                            value={schub1.y_cord}
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeleteRow(e, index, "schub", "schub_1")
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td className="addRow">
                        <Button
                          onClick={(e) => this.handleAddSchub(e, "schub_1")}
                          kind="primary"
                          type="button"
                          className="p-10"
                        >
                          PLUS_SIGN
                        </Button>
                      </td>
                    </tr>

                    {schub.schub_2e.map((schub2e, index) => (
                      <tr key={"schub_2e" + index}>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_2e")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={schub2e.area}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_2e")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={schub2e.harvestYear || ""}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_2e")
                            }
                            name="RR"
                            placeholder="RR"
                            className="half-width-50 "
                            value={schub2e.RR}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_2e")
                            }
                            name="description"
                            placeholder="CULTIVATION_LOCATIONS"
                            className="half-width-50"
                            value={schub2e.description}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_2e")
                            }
                            name="x_cord"
                            placeholder="X_COORDINATE"
                            className="half-width-50 "
                            value={schub2e.x_cord}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_2e")
                            }
                            name="y_cord"
                            placeholder="Y_COORDINATE"
                            className="half-width-50 "
                            value={schub2e.y_cord}
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeleteRow(
                                e,
                                index,
                                "schub",
                                "schub_2e"
                              )
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td className="addRow">
                        <Button
                          onClick={(e) => this.handleAddSchub(e, "schub_2e")}
                          kind="primary"
                          type="button"
                          className="p-10"
                        >
                          PLUS_SIGN
                        </Button>
                      </td>
                    </tr>

                    {schub.schub_1e.map((schub1e, index) => (
                      <tr key={"schub_1e" + index}>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1e")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={schub1e.area}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1e")
                            }
                            name="area"
                            placeholder="SURFACE"
                            className="half-width-50"
                            value={schub1e.harvestYear || ""}
                            readOnly
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1e")
                            }
                            name="RR"
                            placeholder="RR"
                            className="half-width-50 "
                            value={schub1e.RR}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1e")
                            }
                            name="description"
                            placeholder="CULTIVATION_LOCATIONS"
                            className="half-width-50"
                            value={schub1e.description}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1e")
                            }
                            name="x_cord"
                            placeholder="X_COORDINATE"
                            className="half-width-50 "
                            value={schub1e.x_cord}
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onSchubChange(e, index, "schub_1e")
                            }
                            name="y_cord"
                            placeholder="Y_COORDINATE"
                            className="half-width-50 "
                            value={schub1e.y_cord}
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeleteRow(
                                e,
                                index,
                                "schub",
                                "schub_1e"
                              )
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                    <tr key={"schub_1e_Actions"}>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td className="addRow">
                        <Button
                          onClick={(e) => this.handleAddSchub(e, "schub_1e")}
                          kind="primary"
                          type="button"
                          className="p-10"
                        >
                          PLUS_SIGN
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </BackgroundBlock>
          )}
          {!noStatementLine && (
            <BackgroundBlock className="advice-form" key={9}>
              <div className="leverBaarTable mt-30 pb-20 border-bottom">
                <table className="leverBaarTable">
                  <thead>
                    <tr>
                      <th className="capitalizeText">
                        <FormattedMessage id="SURFACE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="HARVEST_YEAR" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="RR" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="GREENHOUSE_OR_LAB" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="X_COORDINATE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="Y_COORDINATE" />
                      </th>
                      <th className="capitalizeText"> &nbsp; </th>
                    </tr>
                  </thead>
                  <tbody>
                    {plantTissue.map((pTissue, index) => (
                      <>
                        <tr key={"w" + index}>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "weefselkweek"
                                )
                              }
                              name="wArea"
                              placeholder="SURFACE"
                              className="half-width-50"
                              value={pTissue.weefselkweek.wArea || ""}
                              readOnly
                              disabled
                            />
                          </td>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "weefselkweek"
                                )
                              }
                              name="wHarvestYear"
                              placeholder="SURFACE"
                              className="half-width-50"
                              value={pTissue.weefselkweek.wHarvestYear || ""}
                              readOnly
                              disabled
                            />
                          </td>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "weefselkweek"
                                )
                              }
                              name="wRR"
                              placeholder="RR"
                              className="half-width-50 "
                              value={pTissue.weefselkweek.wRR}
                            />
                          </td>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "weefselkweek"
                                )
                              }
                              name="wGreenHouse"
                              placeholder="GREENHOUSE"
                              className="half-width-50"
                              value={pTissue.weefselkweek.wGreenHouse}
                            />
                          </td>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "weefselkweek"
                                )
                              }
                              name="wX_cord"
                              placeholder="X_COORDINATE"
                              className="half-width-50 "
                              value={pTissue.weefselkweek.wX_cord}
                            />
                          </td>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "weefselkweek"
                                )
                              }
                              name="wY_cord"
                              placeholder="Y_COORDINATE"
                              className="half-width-50 "
                              value={pTissue.weefselkweek.wY_cord}
                            />
                          </td>
                          <td className="addRow">
                            <Button
                              onClick={(e) => this.handleDeleteTissue(e, index)}
                              kind="primary"
                              type="button"
                              className="p-12"
                            >
                              MINUS_SIGN
                            </Button>
                          </td>
                        </tr>
                        <tr key={"l" + index}>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "laboratorium"
                                )
                              }
                              name="lArea"
                              placeholder="SURFACE"
                              className="half-width-50"
                              value={pTissue.laboratorium.lArea || ""}
                              readOnly
                              disabled
                            />
                          </td>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "laboratorium"
                                )
                              }
                              name="lHarvestYear"
                              placeholder="SURFACE"
                              className="half-width-50"
                              value={pTissue.laboratorium.lHarvestYear || ""}
                              readOnly
                              disabled
                            />
                          </td>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "laboratorium"
                                )
                              }
                              name="lRR"
                              placeholder="RR"
                              className="half-width-50 "
                              value={pTissue.laboratorium.lRR}
                            />
                          </td>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "laboratorium"
                                )
                              }
                              name="lGreenHouse"
                              placeholder="LAB_NAME"
                              className="half-width-50"
                              value={pTissue.laboratorium.lGreenHouse}
                            />
                          </td>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "laboratorium"
                                )
                              }
                              name="lX_cord"
                              placeholder="X_COORDINATE"
                              className="half-width-50 "
                              value={pTissue.laboratorium.lX_cord}
                            />
                          </td>
                          <td>
                            <Input
                              onChange={(e) =>
                                this.onPlantTissueChange(
                                  e,
                                  index,
                                  "laboratorium"
                                )
                              }
                              name="lY_cord"
                              placeholder="Y_COORDINATE"
                              className="half-width-50 "
                              value={pTissue.laboratorium.lY_cord}
                            />
                          </td>
                          <td className="addRow">&nbsp;</td>
                        </tr>
                      </>
                    ))}
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td className="addRow">
                        <Button
                          onClick={(e) => this.handleAddPlantTissue(e)}
                          kind="primary"
                          type="button"
                          className="p-10"
                        >
                          PLUS_SIGN
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </BackgroundBlock>
          )}
          <BackgroundBlock className="advice-from" key={5}>
            <div className="plantingMaterialCheckSection">
              <div className="formLabel">
                <FormattedMessage id="PLANTING_MATERIAL_SOLD" /> :
              </div>
              <div className="checkbox-container">
                <div>
                  <Checkbox
                    key={1}
                    checked={areaalAvailable}
                    borderColor="#CDD2D6"
                    labelText={"YES"}
                    onChange={(value) =>
                      this.handleAreaalChange("areaalAvailable", value)
                    }
                  />
                </div>
                <div>
                  <Checkbox
                    key={2}
                    checked={!areaalAvailable}
                    borderColor="#CDD2D6"
                    labelText={"NO"}
                    onChange={(value) =>
                      this.handleAreaalChange("notAreaalAvailable", value)
                    }
                  />
                </div>
              </div>
            </div>
          </BackgroundBlock>
          {areaalAvailable && (
            <BackgroundBlock className="advice-form" key={6}>
              <div className="mt-30 pb-20 border-bottom">
                <table className="plantingMaterialTable">
                  <thead>
                    <tr>
                      <th className="capitalizeText">
                        <FormattedMessage id="BUYER_COMPANY_NO_KV" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="ADDRESS" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="RESIDENCE" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="PORTIONS" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="QUANTITY_KG" />
                      </th>
                      <th className="capitalizeText">
                        <FormattedMessage id="ORDERS_NUMBER" />
                      </th>
                      <th className="capitalizeText" colSpan={1}>
                        <FormattedMessage id="IVB" />
                      </th>
                      <th className="capitalizeText">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {plantingMaterial.map((plantingMaterial, index) => (
                      <tr key={index}>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="buyerCompanyName"
                            placeholder="BUYER_COMPANY_NO_KV"
                            value={plantingMaterial.buyerCompanyName}
                            className="half-width-50"
                            required
                          />
                        </td>
                        <td>
                          <Input
                            value={plantingMaterial.address}
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="address"
                            placeholder="ADDRESS"
                            className="half-width-50"
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="residence"
                            placeholder="RESIDENCE"
                            value={plantingMaterial.residence}
                            className="half-width-50"
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="numberOfPortions"
                            placeholder="PORTIONS"
                            value={plantingMaterial.numberOfPortions}
                            className="half-width-50"
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="quantity"
                            placeholder="QUANTITY_KG"
                            value={plantingMaterial.quantity}
                            className="half-width-50"
                          />
                        </td>
                        <td>
                          <Input
                            onChange={(e) =>
                              this.onPlantingMaterialChange(e, index)
                            }
                            name="orderNumber"
                            placeholder="ORDERS_NUMBER"
                            value={plantingMaterial.orderNumber}
                            className="half-width-50"
                          />
                        </td>
                        <td>
                          <Select
                            name="IVB"
                            selectedOption={plantingMaterial.IVB}
                            required
                            options={[
                              { value: "CNB", label: "CNB" },
                              { value: "Hobaho", label: "Hobaho" },
                              { value: "IGH", label: "IGH" },
                              {
                                value: "Rechtstreeks",
                                label: formatMessage({ id: "DIRECT" }),
                              },
                              {
                                value: "Overig",
                                label: formatMessage({ id: "OTHER" }),
                              },
                            ]}
                            onChange={(e) =>
                              this.onPlantingMaterialIVBChange(e, index)
                            }
                            className="half-width-50"
                          />
                        </td>
                        <td className="addRow">
                          <Button
                            onClick={(e) =>
                              this.handleDeletePlantingRow(e, index)
                            }
                            kind="primary"
                            type="button"
                            className="p-12"
                          >
                            MINUS_SIGN
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="button-container border-bottom">
                <Button
                  onClick={this.handleAddPlantingMaterial}
                  kind="primary"
                  type="button"
                  className="p-10"
                >
                  PLUS_SIGN
                </Button>
              </div>
            </BackgroundBlock>
          )}
          <BackgroundBlock className="advice-form" key={7}>
            <div className="button-container">
              <Button
                type="button"
                kind="primary"
                onClick={this.handleSubmitForm}
              >
                SUBMIT
              </Button>
            </div>
          </BackgroundBlock>
        </form>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    userName: state.app.userName,
    user: state.app.user,
    currentCustomer: state.app.currentCustomer,
    userLanguage: state.app.user.profile.Language,
    statementLine: state.areaStatements.statementLine,
  }),
  {
    createLelie: areaStatementCreateActions.createLelie,
  }
)(injectIntl(AreaStatementLelie));
